module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_html.js
// module id = 55
// module chunks = 0 1